export default __webpack_public_path__ + "static/media/personal7.27b497b7.jpeg";